import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { usePullRefreshInvalidateTags } from '../../../hooks/usePullRefreshInvalidateTags';
import { communitiesApi } from '../../../redux/api/communities/communitiesApi';
import { COMMUNITIES } from '../../../redux/constants';
import { Paths } from '../../../shared/paths';
import { useStyles } from './Communities.styles';

export default function Communities(props) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { onRefresh } = usePullRefreshInvalidateTags([
    {
      apiSlice: communitiesApi,
      tags: [COMMUNITIES.COMMUNITIES, COMMUNITIES.MY_COMMUNITIES],
    },
  ]);
  const tabsConfig = useMemo(
    () => [
      {
        label: t('communities.allCommunities'),
        path: Paths.communities.toList,
      },
      {
        label: t('communities.myCommunities'),
        path: Paths.communities.toMyList,
      },
    ],
    [i18n.language],
  );

  return (
    <PageContainer title={t('common.communities')} onRefresh={onRefresh}>
      <div className={classes.communitiesWrapper}>
        <AppTabs config={tabsConfig} />
        <div className={classes.tabsContent}>
          <Outlet />
        </div>
      </div>
    </PageContainer>
  );
}
